// src/db/db.js
import sistemaStore from "@/store/sistema";

// ⚠️ MUDANÇA IMPORTANTE: Subimos para 5 para forçar a verificação em todos os dispositivos
const versaoDB = 5; 

const nameDB = sistemaStore.getters.isModeDevelopment()
  ? "nutricao-animal-teste"
  : "nutricao-animal";

/**
 * Verifica se o DB já foi "instalado" usando localStorage.
 * O IndexedDB no iOS odeia verificações destrutivas (abrir/fechar/deletar).
 */
export async function existeBancoDados() {
  const isInstalled = localStorage.getItem(`${nameDB}-instalado`);
  if (isInstalled === 'true') return true;

  try {
    if (indexedDB.databases && typeof indexedDB.databases === 'function') {
      const dbs = await indexedDB.databases();
      const exists = dbs.some((d) => d.name === nameDB);
      if (exists) {
         localStorage.setItem(`${nameDB}-instalado`, 'true');
         return true;
      }
    }
  } catch (e) {
    console.warn("Navegador não suporta listagem de DBs:", e);
  }

  return false;
}

/**
 * Abre conexão.
 */
export async function conexaoDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(nameDB, versaoDB);

    request.onsuccess = (event) => {
      const db = event.target.result;
      localStorage.setItem(`${nameDB}-instalado`, 'true');
      resolve(db);
    };

    request.onerror = () => reject(request.error);
    request.onblocked = () => {
      console.warn("Abertura bloqueada. Feche outras abas do sistema.");
    };
  });
}

export async function iniciarBancoDados() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(nameDB, versaoDB);

    req.onupgradeneeded = (event) => {
      const db = event.target.result;
      
      console.log(`Atualizando DB: Versão Antiga=${event.oldVersion} para Nova=${versaoDB}`);

      // Função auxiliar que só cria se NÃO existir.
      // Isso permite que chamemos ela para todas as tabelas sem medo de erro.
      const ensureStore = (name, options = { autoIncrement: true }) => {
        if (!db.objectStoreNames.contains(name)) {
          db.createObjectStore(name, options);
          console.log(`Criando tabela: ${name}`);
        }
      };

      // --- ESTRATÉGIA DE SEGURANÇA ---
      // Removemos os "if (version < X)" para a criação das tabelas.
      // Motivo: Se o usuário estiver na v4 mas sem tabelas (bug),
      // o ensureStore vai garantir que elas sejam criadas agora na v5.
      
      // Tabelas do Core (V1)
      ensureStore("usuarios-relacionados");
      ensureStore("usuario-logado");
      ensureStore("atalhos-iniciais");
      ensureStore("clientes");
      ensureStore("produtos");
      ensureStore("config-pedidos");
      ensureStore("produtos-pendentes");
      ensureStore("pedidos");
      ensureStore("sincronizacoes");
      ensureStore("base");

      // Tabelas V2
      ensureStore("insumos");
      ensureStore("pedidos-insumos");

      // Tabelas V3
      ensureStore("vt-config");
      ensureStore("vt-visitas");
      ensureStore("vt-produtores");
      ensureStore("vt-sinc");

      // Tabelas V4
      ensureStore("vt-docs");
      
      // Futuras tabelas V5 viriam aqui...
    };

    req.onsuccess = (event) => {
      const db = event.target.result;
      
      localStorage.setItem(`${nameDB}-instalado`, 'true');

      db.onversionchange = () => {
        db.close();
        console.warn("Versão mudou em outra aba. Conexão fechada.");
        window.location.reload();
      };
      resolve(true);
    };

    req.onerror = () => reject(req.error);
    req.onblocked = () => console.warn("Update bloqueado.");
  });
}

export default {
  iniciarBancoDados,
  conexaoDB,
  existeBancoDados,
};